export default {
	add: 'إضافة مهمة',

	table: {
		employee: 'الموظف',
		requestDate: 'تاريخ الطلب',
		type: 'النوع',
		startDate: 'تاريخ البداية',
		endDate: 'تاريخ النهاية',
		cause: 'السبب',
		status: 'حالة الأذن',
	},
	'delete-message-mission': 'هل أنت متأكد أنك تريد حذف هذه المهمة ؟',
};
